// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__OWby8","contacto":"Footer_contacto__dSf4p","logotipo":"Footer_logotipo__JXO2U","whatsappFooter":"Footer_whatsappFooter__oOoI4","logo":"Footer_logo__h3+-z"};